import classNames from "classnames";
import { DComponent } from "../../../../../../components/DComponent";
import { LocalStorage } from "../../../../../../models/LocalStorage";
import { isCountryVN } from "../../../../../../utils/utils";

export default class DeliveryTime extends DComponent {
  constructor({
    parent,
    id,
    delivery = {},
  } = {}) {
    super(arguments[0], parent, id, {
      class: classNames("DeliveryTime")
    }, true);
    this.delivery = delivery;
    this.render();
  }

  loadStyle() {
    const style = require("!!css-loader!resolve-url-loader!sass-loader!./style.scss").toString();
    this.appendStyle(style, "DeliveryTime");
  }

  loadHtml() {
    return require("html-loader!./index.html");
  }

  after() {
    this.setDisplayDelivery(this.delivery);
  }

  setUpDeliveryTime(delivery = {}) {
    if (!Object.keys(delivery).length) {
      this.setDisplayDelivery(false);
      return;
    }

    if (!isCountryVN(LocalStorage.getShipping())) {
      $(".working-day", this.element).html($.i18n("checkout_deliveryTimeOther"));
      return;
    }

    let deliveryFrom = delivery.from ? window.moment(delivery.from * 1000) : "", deliveryTo = delivery.to ? window.moment(delivery.to * 1000) : "";
    if (delivery.to || delivery.from) {
      let lang = LocalStorage.getLanguage();
      deliveryFrom = deliveryFrom ? (lang === "vi" ? deliveryFrom.format("DD/MM/YYYY") : deliveryFrom.format("MMMM D, YYYY")) : "";
      deliveryTo = deliveryTo ? (lang === "vi" ? deliveryTo.format("DD/MM/YYYY") : deliveryTo.format("MMMM D, YYYY")) : "";
      if (delivery.to && delivery.from) {
        $(".working-day", this.element).html($.i18n("checkout_deliveryRange", deliveryFrom, deliveryTo))
      } else {
        $(".working-day", this.element).html($.i18n("checkout_deliveryTime", deliveryFrom || deliveryTo))
      }
    } else {
      deliveryFrom = 7; deliveryTo = 15;
      $(".working-day", this.element).html($.i18n("checkout_deliveryDefault", deliveryFrom, deliveryTo))
    }
  }

  setDisplayDelivery(isShow) {
    isShow ? $(this.element).removeClass("hide") : $(this.element).addClass("hide");
  }
}